import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
} from "reactstrap";

const CreateOrganizationModal = ({
  isOpen,
  toggle,
  onConfirm,
  t,
}) => {
  const [organizationName, setOrganizationName] = useState("");
  
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <h3 className="mb-2">{t("organization.createNewOrganization")}</h3>
        <Form>
          <FormGroup>
            <Input
              id="organizationName"
              name="organizationName"
              placeholder={t("organization.enterOrganizationName")}
              type="text"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
              required
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex justify-content-center mt-2">
          <Button
            color="primary"
            className="float-right mt-4"
            onClick={() => onConfirm(organizationName)}
          >
            {t("subscription.confirm")}
          </Button>
          <Button
            color="secondary"
            className="float-right mt-4"
            onClick={toggle}
          >
            {t("subscription.cancel")}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default CreateOrganizationModal;
